<div class="d-flex justify-content-center align-items-center" style="min-height: 200px;">
  <si-loading-spinner></si-loading-spinner>
</div>
